import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { PathProvider } from "./context/PathContext";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { store } from "./redux/Store";

import "@rainbow-me/rainbowkit/styles.css";
import {
  RainbowKitProvider,
  darkTheme,
  getDefaultConfig,
} from "@rainbow-me/rainbowkit";

import { WagmiProvider } from "wagmi";
import { polygon, sepolia } from "@wagmi/core/chains";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const wagmiConfig = getDefaultConfig({
  appName: "The 365 NFT",
  projectId: "1y0h33hi96i5zxbs",
  chains: [sepolia, polygon],
  ssr: true,
  publicClient: () => ({}),
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <WagmiProvider config={wagmiConfig}>
          <QueryClientProvider client={queryClient}>
            <RainbowKitProvider modalSize="compact" theme={darkTheme()}>
              <PathProvider>
                <App />
                <ReactQueryDevtools initialIsOpen={false} />
                <ToastContainer />
              </PathProvider>
            </RainbowKitProvider>
          </QueryClientProvider>
        </WagmiProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
